import React from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { BUTTON_TYPE, VARIANT } from '@motorway/mw-highway-code/enums';

import { SP_COOKIE_BANNER_EVENTS } from 'Utilities/analytics/analyticsCookieBanner';

import { ACCEPT_ALL_CONSENT } from 'Components/CookieBanner/cookieConsent.constants';
import { applyConsent } from 'Components/CookieBanner/cookieConsent.helpers';

import LocalTexts from '../ulezText.json';

import styles from './Map.scss';

const LocalT = new MDText(LocalTexts);

export const MapPlaceholder = () => {
  const handleAcceptAll = () => {
    SP_COOKIE_BANNER_EVENTS.ACCEPT_ALL_CLICKED('map');
    applyConsent(ACCEPT_ALL_CONSENT);
  };

  return (
    <div className={styles.placeholder} data-testid="map-consent-placeholder">
      <p>{LocalT.translate('map.consentMessage')}</p>
      <Button
        label={LocalT.translate('map.consentAcceptAll') as string}
        onClick={handleAcceptAll}
        type={BUTTON_TYPE.BUTTON}
        variant={VARIANT.PRIMARY}
      />
    </div>
  );
};
